/* globals process */

import React from "react";
import Loadable from "react-loadable";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { hashHistory, IndexRoute, Redirect, Route, Router } from "react-router";
import { syncHistoryWithStore } from "react-router-redux";
import { I18nHOC } from "../js/hocs/I18n";

import { getInstance as getStore } from "store/store";

import App from "containers/app";

import LandingContainer from "containers/pages/landing";

import Version from "components/pages/version.jsx";
import AuthProvider from "./hocs/AuthProvider/authprovider";

import "../less/main.less";
import FirebaseProvider from "./hocs/FirebaseProvider/firebaseProvider";

const ContactContainer = Loadable({
  loader: () => import("./containers/pages/contact"),
  loading: () => ("<div>Loading...</div>"),
});

const AboutContainer = Loadable({
  loader: () => import("./containers/pages/about"),
  loading: () => ("<div>Loading...</div>"),
});

const ConnectContainer = Loadable({
  loader: () => import("./containers/pages/connect"),
  loading: () => ("<div>Loading...</div>"),
});

const FAQ = Loadable({
  loader: () => import("./components/pages/faq/faq.jsx"),
  loading: () => ("<div>Loading...</div>"),
});

const PrivacyPolicy = Loadable({
  loader: () => import("./components/pages/privacyPolicy/privacyPolicy.jsx"),
  loading: () => ("<div>Loading...</div>"),
});

const TermsOfUse = Loadable({
  loader: () => import("./components/pages/termsOfUse/termsOfUse.jsx"),
  loading: () => ("<div>Loading...</div>"),
});

const CancelSubscription = Loadable({
  loader: () => import("./components/pages/cancelSubscription/cancelSubscription.jsx"),
  loading: () => ("<div>Loading...</div>"),
});

const store = getStore();
const history = syncHistoryWithStore(hashHistory, store);

const router = (
  <I18nHOC>
    <Provider store={store}>
      <FirebaseProvider>
        <AuthProvider>
          <Router onUpdate={() => window.scrollTo(0, 0)} history={history}>
            <Route path="/" component={App}>
              <IndexRoute component={LandingContainer} />
              <Route path="/contact"
                     component={ContactContainer}
              />
              <Route path="/about"
                     component={AboutContainer}
              />
              <Route path="/connect"
                     component={ConnectContainer}
              />
              <Route path="/faq"
                     component={FAQ}
              />
              <Route path="/privacy-policy"
                     component={PrivacyPolicy}
              />
              <Route path="/terms-of-use"
                     component={TermsOfUse}
              />
              <Route path="/cancel-subscription"
                     component={CancelSubscription}
              />
            </Route>
            <Route path="/version" component={Version} />
            {/*<Route path="*" component={PageNotFoundContainer} />*/}
            <Redirect from="*" to="/" />
          </Router>
        </AuthProvider>
      </FirebaseProvider>
    </Provider>
  </I18nHOC>
);

const app = document.getElementById("app");


render(router, app);




// WEBPACK FOOTER //
// ./src/js/index.jsx